export const AMOUNT_SIGNS = {
  POSITIVE: "+",
  NEGATIVE: "-",
};

export function normalizeAmountSign(value) {
  return value === AMOUNT_SIGNS.POSITIVE || value === AMOUNT_SIGNS.NEGATIVE
    ? value
    : null;
}

export function deriveAmountSign(type, data = {}) {
  if (data.transfer_role === "origin") return AMOUNT_SIGNS.NEGATIVE;
  if (data.transfer_role === "destination") return AMOUNT_SIGNS.POSITIVE;
  return type === "income" ? AMOUNT_SIGNS.POSITIVE : AMOUNT_SIGNS.NEGATIVE;
}

export function getTransactionAmountSign(transaction = {}) {
  return normalizeAmountSign(transaction.amount_sign) ||
    deriveAmountSign(transaction.type, transaction);
}

export function withAmountSign(type, data = {}) {
  return {
    ...data,
    amount_sign: normalizeAmountSign(data.amount_sign) || deriveAmountSign(type, data),
  };
}

export function buildAmountSignBackfill(transactions = []) {
  return transactions.map((tx) => {
    const sign = normalizeAmountSign(tx.amount_sign);
    if (sign) return tx;

    return {
      ...tx,
      amount_sign: deriveAmountSign(tx.type, tx),
    };
  });
}
